import { render, staticRenderFns } from "./RecoverViaEmail.vue?vue&type=template&id=7cf4c36e&"
import script from "./RecoverViaEmail.vue?vue&type=script&lang=js&"
export * from "./RecoverViaEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports